import api from "utils/apiService";
// ! Sign in action
const BASEURL = process.env.REACT_APP_ENDPOINT;

const handleLogin = async (phone, password) => {
  try {
    const res = await fetch(`${BASEURL}/users/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phoneNumber: phone,
        password: password,
        role: "admin",
      }),
    });

    if (res.status === 401) {
      return { error: "الهاتف أو كلمة المرور غير صحيحة" };
    }

    if (res.ok) {
      const data = await res.json();
      const token = data.token;

      return { success: "تم تسجيل الدخول بنجاح", token };
    }
    return res;
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Accept or Reject Offers action
const handleOfferStatus = async (offerId, status) => {
  const url =
    status === "accept"
      ? `/offers/acceptOffer/${offerId}`
      : `/offers/rejectOffer/${offerId}`;
  try {
    const res = await api.post(url);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم تحديث حالة العرض بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

const handleDeleteOffers = async (adId) => {
  try {
    const res = await api.delete(`/offers/${adId}`);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم حذف الإعلان بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Toggle Contractors action
const handleToggleContractors = async (contractorId, status, reason) => {
  const body = status === "deactivate" ? { deactivateReason: reason } : {};
  try {
    // /users/:id/toggleActive/
    const res = await api.patch(`/users/${contractorId}/toggleActive`, body);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم تحديث حالة المقاول بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Request Actions
const handleRequestAction = async (requestId, action) => {
  const url =
    action === "accepted"
      ? `/users/acceptContractorRequest/${requestId}`
      : `/users/rejectContractorRequest/${requestId}`;

  try {
    const res = await api.patch(url);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم تحديث حالة الطلب بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Supplier-request actions (accept / reject)
const handleSupplierRequestAction = async (requestId, action) => {
  const url =
    action === "accepted"
      ? `/users/acceptSupplierRequest/${requestId}`
      : `/users/rejectSupplierRequest/${requestId}`;
  try {
    const res = await api.patch(url);
    if (res.error) return { error: res.error };
    return { success: "تم تحديث حالة الطلب بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Send Notification for all action
const handleSendNotification = async (body) => {
  try {
    const res = await api.post(
      "/notifications/createNotificationByAdmin",
      body
    );

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم إرسال الإشعار بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Toggle Ads Status action
const handleToggleAdsStatus = async (adId, status) => {
  try {
    const res = await api.patch(`/ads/${adId}`, { status });

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم تحديث حالة الإعلان بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Delete Ads action
const handleDeleteAds = async (adId) => {
  try {
    const res = await api.delete(`/ads/${adId}`);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم حذف الإعلان بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Delete User action
const handleDeleteUser = async (userId) => {
  try {
    const res = await api.delete(`/users/${userId}`);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم حذف المستخدم بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};
// ! Create Ads action
const handleCreateAds = async (formData) => {
  try {
    const res = await api.post("/ads", formData);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم إضافة الإعلان بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Accept or Reject Payment
const handleAcceptRejectPayment = async (paymentId, action) => {
  const url =
    action === "accept"
      ? `/paymentRequests/complete/${paymentId}`
      : `/paymentRequests/reject/${paymentId}`;

  try {
    const res = await api.post(url);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم تحديث حالة الطلب بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};

// ! Accept or Reject Commercial Register Change Request
const handleCommercialRegisterRequest = async (requestId, action) => {
  if (!requestId) {
    return { error: "معرف الطلب غير موجود" };
  }

  const url =
    action === "accept"
      ? `/commercialRegisterChangeRequests/accept/${requestId}`
      : `/commercialRegisterChangeRequests/reject/${requestId}`;

  try {
    const res = await api.post(url);

    if (res.error) {
      return { error: res.error };
    }

    return { success: "تم تحديث حالة الطلب بنجاح" };
  } catch (error) {
    return { error: "حدث خطأ يرجي المحاولة لاحقًا" };
  }
};
export {
  handleLogin,
  handleOfferStatus,
  handleToggleContractors,
  handleRequestAction,
  handleSupplierRequestAction,
  handleSendNotification,
  handleToggleAdsStatus,
  handleCreateAds,
  handleAcceptRejectPayment,
  handleCommercialRegisterRequest,
  handleDeleteAds,
  handleDeleteUser,
  handleDeleteOffers,
};
